import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { OktaAuthModule } from '@okta/okta-angular';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, OktaAuthModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: [MainLayoutComponent]
})
export class AppComponent {
  title = 'artist-match-admin-panel';
  constructor() {
    console.log('++++++ environment' + Date.now(), environment);
    console.log(window.location.origin + '/login/callback');
  }
}
